import React from 'react'
import { Divider, Select } from 'antd'
import ru from 'react-phone-input-2/lang/ru.json'
import { SPLASHED_COUNTRIES } from '../../constants/countries'


export default class PhonePrefixMultiselect extends React.Component {
  constructor(props, context) {
    super(props, context)

    // TODO take priority from api
    this.highPriorityCountries = SPLASHED_COUNTRIES.filter(country => country.code.some(countryCode => ['ru', 'ro'].includes(countryCode)))
    this.countries = SPLASHED_COUNTRIES.filter(country => !['ru', 'ro'].includes(country.code))
  }

  /**
   * Handler of countries changing.
   * @param countries Array of countries.
   */
  handleCountriesChange = (countries) => {
    this.triggerChange(countries)
  };

  triggerChange = (changedValue) => {
    const { onChange, value } = this.props
    if (onChange) {
      onChange([...changedValue])
    }
  };

  render() {
    const { value } = this.props
    return (
      <Select
        mode='multiple'
        style={{ width: '100%' }}
        placeholder='Выбирите префиксы для клиентов'
        optionLabelProp='label'
        onChange={this.handleCountriesChange}
        value={value}
      >
        <Select.OptGroup label='Страны по умолчанию'>
          {this.highPriorityCountries.map(country => (
            <Select.Option key={country.number} value={country.number} label={`${country.code.join(', ')} +${country.number}`} >
              {country.name.join(', ')} +{country.number}
            </Select.Option>
        ))}
        </Select.OptGroup>
        <Select.OptGroup label='Страны мира'>
          {this.countries.map(country => (
            <Select.Option key={country.number} value={country.number} label={`${country.code.join(', ')} +${country.number}`} >
              {country.name.join(', ')} +{country.number}
            </Select.Option>
          ))}
        </Select.OptGroup>
      </Select>
    )
  }
}



// WEBPACK FOOTER //
// src/components/PhonePrefixMultiselect/index.jsx